import { render, staticRenderFns } from "./c-dose-card.vue?vue&type=template&id=248cc110&scoped=true&"
import script from "./c-dose-card.vue?vue&type=script&lang=js&"
export * from "./c-dose-card.vue?vue&type=script&lang=js&"
import style0 from "./c-dose-card.vue?vue&type=style&index=0&id=248cc110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cc110",
  null
  
)

export default component.exports